/**
 * @author Jafar Amini in March 2018.
 */
export enum ValidationSrcType {
  FormControl = <any>'FormControl',
  CustomValue = <any> 'CustomValue'
}
